function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5999 11.8999L2.20332 17.5609C1.73114 18.3478 1.85515 19.3551 2.50409 20.0041L3.3792 20.8792C3.8867 21.3867 4.62723 21.5834 5.31965 21.3945L11.8999 19.5999",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3999 11.8999L25.7964 17.5609C26.2686 18.3478 26.1446 19.3551 25.4957 20.0041L24.6206 20.8792C24.1131 21.3867 23.3725 21.5834 22.6801 21.3945L16.0999 19.5999",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.3411 11.2526C4.78528 10.5452 5.09873 9.5006 5.95222 9.21611L8.98441 8.20537C9.76633 7.94474 10.5903 8.46821 10.6866 9.28677L11.9 19.6002L5.3411 11.2526Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.6587 11.2526C23.2145 10.5452 22.901 9.5006 22.0475 9.21611L19.0153 8.20537C18.2334 7.94474 17.4094 8.46821 17.3131 9.28677L16.0998 19.6002L22.6587 11.2526Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6234 8.11043C10.5576 7.51806 11.0213 7 11.6173 7H16.3827C16.9787 7 17.4424 7.51807 17.3766 8.11043L16.1 19.6H11.9L10.6234 8.11043Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCroissant = function SvgCroissant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCroissant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/croissant.03edd60b.svg";
export { ForwardRef as ReactComponent };